function sineOut(t) {
  return Math.sin(t * Math.PI/2)
}

module.exports = sineOut


//////////////////
// WEBPACK FOOTER
// ./node_modules/eases/sine-out.js
// module id = 158
// module chunks = 0